// extracted by mini-css-extract-plugin
module.exports = {"wrap":"style_wrap__dQlxJ","button":"style_button__1XBuE","cta":"style_cta__2tWpE","text":"style_text__2nV2I","icon":"style_icon__2cVTR"};